import Util from '@/lib/util'
export default [
    {
        title:Util.L('SoCode'),
        width: 150,
        key:'soCode'
    },
    {
        title:Util.L('SoRequestCode'),
        width: 150,
        key:'sorExternalCode'
    },
    {
        title:Util.L('AOGroupCode'),
        width: 150,
        key:'aoGroupCode'
    },
    {
        title:Util.L('OutboundMode'),
        width: 150,
        key:'outboundModeName'
    },
    {
        title:Util.L('Status'),
        width: 150,
        key:'statusName'
    },
   
    {
        title:Util.L('Customer'),
        width: 150,
        key:'customerInfo'
    },
    {
        title:Util.L('Province'),
        width: 150,
        key:'customerProvinceName'
    },
    {
        title:Util.L('InvoiceNo'),
        width: 150,
        key:'invoiceNo'
    },
    {
        title:Util.L('SoDate'),
        width: 150,
        key:'soDate',
        render:(h:any,params:any)=>{
            return h("span", Util.toViewDateString(params.row.soDate));
        }
    },
    {
        title:Util.L('SKU'),
        width: 150,
        key:'sku'
    },
    {
        title:Util.L('ProductName'),
        width: 150,
        key:'productName'
    },
    {
        title:Util.L('ModelSku'),
        width: 150,
        key:'modelSKU'
    },
    {
        title:Util.L('AssetType'),
        width: 150,
        key:'assetTypeName'
    },
    {
        title:Util.L('ConditionType'),
        width: 150,
        key:'conditionTypeName'
    },
    {
        title:Util.L('OrderQty'),
        width: 100,
        key:'orderQty',
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.orderQty));
        }
    },
    {
        title:Util.L('AllocatingQty'),
        width: 100,
        key:'allocatingQty',
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.allocatingQty));
        }
    },
    {
        title:Util.L('PickedQty'),
        width: 100,
        key:'pickedQty',
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.pickedQty));
        }
    },
    {
        title:Util.L('PackedQty'),
        width: 100,
        key:'packedQty',
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.packedQty));
        }
    },
    {
        title:Util.L('ChargedQty'),
        width: 100,
        key:'chargedQty',
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.chargedQty));
        }
    },
    {
        title:Util.L('UnChargedQty'),
        width: 100,
        key:'unChargedQty',
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.unChargedQty));
        }
    }
]